import React from 'react'
import PageHeader from '../components/PageHeader';
import DeployTrigger from '../components/DeployTrigger';
import Help from '../components/Help';
import { helpPagesData } from '../utils/helper';
import { NavLink } from 'react-router-dom';

const AddSection = () => {
  return (
    <div>
          <PageHeader pageTitle="Create Section">
            
                <Help
                  title={helpPagesData.pages.title}
                  message={helpPagesData.pages.message}
                  items={helpPagesData.pages.items}
                />
                <NavLink to="/blogs/add-blogs" className="btn-black">
                  Save
                </NavLink>
          
            </PageHeader>
      <div className="page-container">
        
        </div>
    </div>
  )
}

export default AddSection;
